(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-product"]) return;
  try {
    
function initializeHalloween(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const motion=root.querySelector('.motion-control');
  const video=root.querySelector('.campaign-video');
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  function setPaused(paused){
    root.classList.toggle('is-paused',paused);
    motion.setAttribute('aria-pressed',String(paused));
    motion.textContent=paused?root.dataset.playLabel:root.dataset.pauseLabel;
    if(video){if(paused){video.pause();}else{video.muted=true;video.play().catch(()=>setPaused(true));}}
  }
  setPaused(preference.matches);
  preference.addEventListener('change',event=>setPaused(event.matches));
  motion.addEventListener('click',()=>setPaused(!root.classList.contains('is-paused')));
  root.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',()=>{root.querySelector('[data-price]').textContent=input.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);}));
}
document.querySelectorAll('[data-halloween]').forEach(initializeHalloween);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-halloween]').forEach(initializeHalloween));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
